import styled from "styled-components";

export const LogoDiv = styled.div`
  max-width: 37.7rem;
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: 0 2rem;
  gap: 2.2rem;

  & :nth-child(1) {
    width: 24.3rem;
    height: 5.6rem;
  }

  & > div {
    width: 90%;
    padding: 1.4rem 1.8rem;
    border: 0.1rem solid var(--color-grey-20);
    display: flex;
    align-items: center;
    border-radius: 0.5rem;
    gap: 1.9rem;
    & > div:nth-child(1) {
      width: 6rem;
      height: 6rem;
      background: rgba(39, 174, 96, 0.1);
      border-radius: 0.5rem;
      display: flex;
      align-items: center;
      justify-content: center;
      & > img {
        height: 2.4rem;
        width: 2.4rem;
      }
    }

    & > div:nth-child(2) {
      width: 26.1rem;
      height: 6.6rem;
      word-break: break-all;
      letter-spacing: 0.01rem;
      & span > span {
        color: var(--color-grey-100);
        font-weight: 600;
      }
    }
  }

  & :nth-child(3) {
    height: 7.9rem;
    width: 18.1rem;
  }

  @media (max-width: 768px) {
    max-width: 37.7rem;
    width: 100%;
    & :nth-child(3) {
      display: none;
    }
  }
`;
